import React from 'react';
import { useTranslation } from 'react-i18next';
import type { ArticleSortField } from '../types';

interface ArticleToolbarProps {
  sort: ArticleSortField;
  pageSize: number;
  onSortChange: (sort: ArticleSortField) => void;
  onPageSizeChange: (size: number) => void;
}

const ArticleToolbar: React.FC<ArticleToolbarProps> = ({
  sort,
  pageSize,
  onSortChange,
  onPageSizeChange,
}) => {
  const { t } = useTranslation();
  const controlClass = 'h-11 w-full rounded-xl border border-outline-variant bg-white px-3 text-body-md text-on-surface focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/15';

  return (
    <div className="flex flex-col gap-3 border-b border-outline-variant bg-white px-4 py-4 sm:flex-row sm:items-end sm:justify-end sm:px-5">
      <div className="grid w-full grid-cols-1 gap-2 sm:w-auto sm:grid-cols-[minmax(190px,240px)_140px]">
        <label className="flex min-w-0 flex-col gap-1.5 font-label-sm text-secondary">
          {t('admin.articles.toolbar.sort')}
          <select
            className={controlClass}
            value={sort}
            onChange={(event) => onSortChange(event.target.value as ArticleSortField)}
          >
            <option value="id">{t('admin.articles.sort.id')}</option>
            <option value="title">{t('admin.articles.sort.title')}</option>
            <option value="createAt">{t('admin.articles.sort.create_at')}</option>
            <option value="updateAt">{t('admin.articles.sort.update_at')}</option>
          </select>
        </label>
        <label className="flex min-w-0 flex-col gap-1.5 font-label-sm text-secondary">
          {t('admin.articles.toolbar.page_size')}
          <select
            className={controlClass}
            value={pageSize}
            onChange={(event) => onPageSizeChange(Number(event.target.value))}
          >
            {[10, 20, 50].map((size) => (
              <option key={size} value={size}>{t('admin.articles.toolbar.per_page', { size })}</option>
            ))}
          </select>
        </label>
      </div>
    </div>
  );
};

export default ArticleToolbar;
